import PropTypes from "prop-types";
import React from "react";
import { MenuItem, DropdownButton } from "react-bootstrap";

import SettingActions from "../../actions/SettingActions";

import UserStore from "../../stores/UserStore";

export default class MultipleCurrenciesEnabledSetting extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = MultipleCurrenciesEnabledSetting.getStoreState();
		this._onChange = this._onChange.bind(this);
		this.handleEnabledChange = this.handleEnabledChange.bind(this);
	}

	static getStoreState()
	{
		let multipleCurrenciesEnabled = UserStore.areMultipleCurrenciesEnabled();

		return {
			multipleCurrenciesEnabled
		};
	}

	async handleEnabledChange(setEnabled)
	{
		this.setState({ multipleCurrenciesEnabled: setEnabled });
		await SettingActions.updateUserProfile("MultipleCurrenciesEnabled", setEnabled);
	}

	_onChange()
	{
		this.setState(MultipleCurrenciesEnabledSetting.getStoreState());
	}

	componentDidMount()
	{
		UserStore.addChangeListener(this._onChange);
	}

	componentWillUnmount()
	{
		UserStore.removeChangeListener(this._onChange);
	}

	render()
	{
		const selectedValue = this.state.multipleCurrenciesEnabled;
		let enabled = this.props.enabled;

		const title = selectedValue ? "Yes" : "No";

		return (
			<DropdownButton
				onSelect={this.handleEnabledChange}
				title={title}
				id="multipleCurrenciesEnabledChange"
				disabled={!enabled}
			>
				<MenuItem
					key={"no"}
					eventKey={false}
					className={selectedValue ? "" : "active"}
				>
					No
				</MenuItem>
				<MenuItem
					key={"yes"}
					eventKey={true}
					className={selectedValue ? "active" : ""}
				>
					Yes
				</MenuItem>
			</DropdownButton>
		);
	}
}

MultipleCurrenciesEnabledSetting.propTypes = {
	enabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./Components/components/settings/MultipleCurrenciesEnabledSetting.jsx